/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'twitter': {
    width: 500,
    height: 500,
    viewBox: '0 0 500 500',
    data: '<path pid="0" _fill="#1B1625" d="M499.997 88.847c-18.724 8.59-38.581 14.23-58.916 16.732 21.148-13.17 37.416-33.98 45.071-58.814-20.134 12.381-42.163 21.104-65.136 25.792C401.629 51.102 374.516 38.95 346.15 39c-56.626 0-102.585 47.579-102.585 106.27 0 8.34.905 16.469 2.679 24.23-85.265-4.44-160.832-46.733-211.436-111.044-8.836 15.678-13.876 33.954-13.876 53.436 0 36.856 18.102 69.392 45.621 88.454-16.293-.517-32.228-5.076-46.47-13.294v1.355c0 51.48 35.363 94.437 82.267 104.221a99.67 99.67 0 0 1-46.317 1.818c13.06 42.231 50.955 72.952 95.823 73.844-35.1 28.46-79.325 45.484-127.396 45.484-8.174-.01-16.341-.508-24.46-1.487 45.392 30.145 99.323 47.763 157.247 47.763 188.68 0 291.84-161.98 291.84-302.45 0-4.594 0-9.19-.319-13.75 20.074-15.05 37.408-33.673 51.197-55.003h.032z"/>'
  }
})
